<script lang="ts" setup>
import { computed } from 'vue'

export interface OverflowSurfaces {
  top?: number
  right?: number
  bottom?: number
  left?: number
}

const props = withDefaults(defineProps<OverflowSurfaces>(), {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  size: 'normal',
})

const overflowSurfaces = computed(() =>
  [
    props.top && 'top', //
    props.right && 'right',
    props.bottom && 'bottom',
    props.left && 'left',
  ].filter(i => i),
)
</script>

<template>
  <div
    v-for="(surface, idx) in overflowSurfaces"
    :key="idx"
    class="gwsofsrfc_surface"
    :class="surface"
  >
    <slot :name="surface"> </slot>
  </div>
</template>

<style lang="scss" scoped>
.gwsofsrfc_surface {
  position: absolute;
  z-index: 4;

  --gwsofsrfc-inset-top: 0 0 auto 0;
  --gwsofsrfc-inset-right: 0 0 0 auto;
  --gwsofsrfc-inset-bottom: auto 0 0 0;
  --gwsofsrfc-inset-left: 0 auto 0 0;
}
.top {
  inset: var(--gwsofsrfc-inset-top);
  width: 100%;
}
.right {
  inset: var(--gwsofsrfc-inset-right);
  height: 100%;
}
.bottom {
  inset: var(--gwsofsrfc-inset-bottom);
  width: 100%;
}
.left {
  inset: var(--gwsofsrfc-inset-left);
  height: 100%;
}
</style>
